(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["objet-en-mouvement"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('okan-objet-en-mouvement-v2')) return;
  customElements.define('okan-objet-en-mouvement-v2', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (this.controller || !this.isConnected) return;
      this.video = this.querySelector('video');
      this.surface = this.querySelector('[data-surface]');
      this.status = this.querySelector('[data-status]');
      if (!this.video || !this.surface) return;
      this.controller = new AbortController();
      this.pending = false;
      this.resume = false;
      this.visible = false;
      this.wantsPlay = this.dataset.autoplay === 'true';
      delete this.dataset.frameReady;
      this.video.autoplay = this.dataset.autoplay === 'true';
      this.video.controls = false;
      this.video.muted = true;
      this.video.loop = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.video.playbackRate = Number(this.dataset.speed) || 1;
      if (!this.wantsPlay) this.video.pause();
      const on = (target, type, fn) => target.addEventListener(type, fn, { signal: this.controller.signal });
      on(this.video, 'loadedmetadata', () => this.ready());
      on(this.video, 'loadeddata', () => this.reveal());
      on(this.video, 'canplay', () => {
        this.reveal();
        if (this.visible && this.wantsPlay && !this.drag && !this.pending) this.play();
      });
      on(this.video, 'durationchange', () => this.ready());
      on(this.video, 'playing', () => this.reveal());
      on(this.video, 'seeked', () => {
        if (this.pending) this.seek();
        else if (this.resume) this.play();
      });
      on(this.video, 'error', () => {
        this.resume = false;
        this.status.textContent = 'Cette vidéo ne peut pas être chargée.';
      });
      on(this.surface, 'pointerdown', e => {
        if (!e.isPrimary || e.button !== 0 || !this.end) return;
        this.resume = false;
        this.drag = { id: e.pointerId, x: e.clientX, y: e.clientY, time: this.video.currentTime, active: false };
      });
      on(this.surface, 'pointermove', e => this.move(e));
      on(this.surface, 'pointerup', e => {
        if (!this.drag || this.drag.id !== e.pointerId) return;
        const active = this.drag.active;
        if (active) this.move(e);
        this.stopDrag();
        if (active) {
          this.resume = true;
          this.wantsPlay = this.resume;
          if (this.resume && !this.pending && !this.video.seeking) this.play();
        } else if (this.video.paused) { this.wantsPlay = true; this.play(); }
        else { this.wantsPlay = false; this.video.pause(); }
      });
      for (const type of ['pointercancel', 'lostpointercapture']) {
        on(this.surface, type, () => this.stopDrag());
      }
      on(this.surface, 'pointerleave', () => {
        if (this.drag && !this.drag.active) this.stopDrag();
      });
      on(this.surface, 'keydown', e => {
        if (!['ArrowLeft', 'ArrowRight', ' ', 'Home', 'End'].includes(e.key)) return;
        e.preventDefault();
        this.resume = false;
        if (e.key === ' ') {
          if (this.video.paused) { this.wantsPlay = true; this.play(); }
          else { this.wantsPlay = false; this.video.pause(); }
          return;
        }
        if (!this.end) return;
        this.wantsPlay = false;
        this.video.pause();
        this.target = e.key === 'Home' ? 0 : e.key === 'End' ? this.end
          : Math.max(0, Math.min(this.end, this.video.currentTime + (e.key === 'ArrowRight' ? 1 : -1) * this.end / 36));
        this.pending = true;
        this.seek();
      });
      on(document, 'visibilitychange', () => {
        if (document.hidden) { this.resume = false; this.video.pause(); }
        else if (this.visible && this.wantsPlay && !this.drag) this.play();
      });
      on(window, 'pageshow', () => {
        if (this.visible && this.wantsPlay && !this.drag) this.play();
      });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (!this.visible) { this.resume = false; this.video.pause(); }
        else if (this.wantsPlay && !this.drag) this.play();
      });
      this.observer.observe(this);
      this.ready();
      this.reveal();
    }
    reveal() {
      if (this.video.readyState < 2) return;
      cancelAnimationFrame(this.revealFrame);
      this.revealFrame = requestAnimationFrame(() => {
        this.revealFrame = requestAnimationFrame(() => {
          if (this.isConnected && this.video.readyState >= 2) this.dataset.frameReady = '';
        });
      });
    }
    ready() {
      if (!Number.isFinite(this.video.duration) || this.video.duration <= 0) return;
      this.end = Math.max(.001, this.video.duration - .04);
      this.status.textContent = '';
      if (this.visible && this.wantsPlay && !this.drag) this.play();
    }
    move(e) {
      const drag = this.drag;
      if (!drag || drag.id !== e.pointerId) return;
      const dx = e.clientX - drag.x;
      const dy = e.clientY - drag.y;
      if (!drag.active) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 6) return;
        if (Math.abs(dy) > Math.abs(dx)) { this.stopDrag(); return; }
        drag.active = true;
        this.video.pause();
        this.surface.setPointerCapture(e.pointerId);
        this.dataset.dragging = '';
      }
      const width = this.surface.getBoundingClientRect().width;
      if (!width) return;
      let time = drag.time + dx / width * this.end;
      time = ((time % this.end) + this.end) % this.end;
      this.target = time;
      this.pending = true;
      this.seek();
    }
    seek() {
      cancelAnimationFrame(this.seekFrame);
      this.seekFrame = requestAnimationFrame(() => {
        if (!this.isConnected || !this.pending || this.video.seeking) return;
        this.pending = false;
        try { this.video.currentTime = this.target; }
        catch (_) { this.status.textContent = 'Touchez pour lire la vidéo.'; }
      });
    }
    stopDrag() {
      const drag = this.drag;
      this.drag = null;
      delete this.dataset.dragging;
      if (drag && this.surface.hasPointerCapture(drag.id)) this.surface.releasePointerCapture(drag.id);
    }
    async play() {
      this.resume = false;
      if (!this.isConnected || !this.visible || document.hidden || this.drag?.active || this.pending || this.video.seeking) return;
      try { await this.video.play(); this.status.textContent = ''; }
      catch (_) { this.status.textContent = 'Touchez l’objet pour lancer la rotation.'; }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.revealFrame);
      cancelAnimationFrame(this.seekFrame);
      if (!this.controller) return;
      this.stopDrag();
      this.controller.abort();
      this.controller = null;
      this.observer.disconnect();
      this.resume = false;
      this.video.pause();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["okan-alma-compact"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('okan-alma-compact')) {
  customElements.define('okan-alma-compact', class extends HTMLElement {
    connectedCallback() {
      const scope = this.closest('.shopify-section');
      if (!scope) return;
      const shorten = () => {
        scope.querySelectorAll('#alma-widget .alma-payment-plans-payment-info p[class*="openModalInfo"]').forEach(link => {
          const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
          let node;
          while ((node = walker.nextNode())) {
            const updated = node.nodeValue.replace(/Cliquez pour en savoir plus/gi, 'En savoir plus');
            if (updated !== node.nodeValue) node.nodeValue = updated;
          }
        });
      };
      this.observer?.disconnect();
      this.observer = new MutationObserver(shorten);
      this.observer.observe(scope, { childList: true, subtree: true, characterData: true });
      shorten();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["okan-bundle-composition"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('okan-bundle-price')) {
  customElements.define('okan-bundle-price', class extends HTMLElement {
    connectedCallback() {
      // Wait for the element children to finish parsing before reading them.
      this.startFrame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected) return;
      this.scope = this.closest('.product-details');
      if (!this.scope) return;
      this.total = this.querySelector('[data-bundle-total]');
      this.compare = this.querySelector('[data-bundle-compare]');
      this.target = this.querySelector('.okan-bundle-price__alma');
      this.lastAmount = null;
      this.observer?.disconnect();
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.sync();
      });
      this.observer.observe(this.scope, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:["cart-item-count","data-drawer-status"]});
      this.modalObserver = new MutationObserver(() => this.decorateModal());
      this.modalObserver.observe(document.body,{childList:true,subtree:true});
      this.sync();
      this.decorateModal();
      // The official app and its library load asynchronously.
      this.retry = setInterval(() => this.sync(), 500);
      this.stopRetry = setTimeout(() => clearInterval(this.retry), 60000);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      this.gridObserver?.disconnect();
      this.ctaObserver?.disconnect();
      this.purchaseStyleObserver?.disconnect();
      this.alignedCTA = null;
      this.alignedForm = null;
      this.alignPurchaseRow = null;
      this.measuredGrid = null;
      this.observer?.disconnect();
      this.modalObserver?.disconnect();
      this.sizeGuide?.remove();
      this.sizeGuide = null;
      clearInterval(this.retry);
      clearTimeout(this.stopRetry);
    }

    decoratePhotoActions(bundle) {
      bundle.querySelectorAll('.gbbMixProductCard').forEach(card => {
        const wrap=card.querySelector('.gbbMixProductCardImageWrapper');
        if(!wrap) return;
        let add=wrap.querySelector('.okan-photo-add');
        if(!add){
          add=document.createElement('button');add.type='button';add.className='okan-photo-add';add.textContent='+';
          add.setAttribute('aria-label','Ajouter ce bijou — choisir une taille');
          add.addEventListener('click',event=>{
            event.preventDefault();event.stopPropagation();
            if(card.dataset.isMultiVariant==='true') card.querySelector('.gbbMixProductCardImage')?.click();
            else card.querySelector('.gbbMixProductCardAddBtn,.gbbMixProductCardQtyIncrement')?.click();
          });wrap.append(add);
        }
        let badge=wrap.querySelector('.okan-photo-count');
        if(!badge){badge=document.createElement('span');badge.className='okan-photo-count';wrap.append(badge);}
        // The card counter reflects only the last variant. Sum the SDK variants instead.
        let count=Number(card.dataset.productQuantity)||0;
        const sdk=window.gbb?.sdk;
        if(sdk?.f?.getVariantDataById){
          count=0;bundle.querySelectorAll('.gbbMixBundleCartItem').forEach(row=>{
            const v=sdk.f.getVariantDataById(row.dataset.variantId);
            if(String(v?.product_id ?? v?.productId)===card.dataset.productId) count+=Number(row.dataset.quantity)||0;
          });
        }
        if(badge.textContent!==String(count)) badge.textContent=String(count);
        badge.hidden=count===0;badge.setAttribute('aria-label',count+' bijou(x) sélectionné(s)');
      });
      bundle.querySelectorAll('.gbbMixBundleCartItem').forEach(row=>{
        const right=row.querySelector('.gbbMixBundleCartItemRightSec');
        if(!right || !window.gbb?.sdk?.f?.updateCartItem) return;
        const remove=right.querySelector('.gbbMixBundleCartItemRemoveBtn');
        if(remove&&!remove.dataset.okanBound){
          remove.dataset.okanBound='true';
          remove.addEventListener('click',event=>{
            event.preventDefault();event.stopImmediatePropagation();
            window.gbb.sdk.f.updateCartItem(row.dataset.uniqueId,{updateQuantityBy:-(Number(row.dataset.quantity)||1),showToast:true});
          },true);
        }
        let controls=right.querySelector('.okan-size-quantity');
        if(!controls){
          controls=document.createElement('div');controls.className='okan-size-quantity';
          const value=document.createElement('span');value.setAttribute('aria-live','polite');
          [-1,1].forEach(delta=>{
            const button=document.createElement('button');button.type='button';button.textContent=delta<0?'−':'+';
            button.setAttribute('aria-label',(delta<0?'Réduire':'Augmenter')+' la quantité de cette taille');
            button.addEventListener('click',async event=>{
              event.preventDefault();event.stopPropagation();
              if(controls.dataset.busy==='true') return;
              controls.dataset.busy='true';controls.querySelectorAll('button').forEach(b=>b.disabled=true);
              try {await window.gbb.sdk.f.updateCartItem(row.dataset.uniqueId,{updateQuantityBy:delta,showToast:true});}
              finally {controls.dataset.busy='false';controls.querySelectorAll('button').forEach(b=>b.disabled=false);this.sync();}
            });controls.append(button);if(delta<0)controls.append(value);
          });right.prepend(controls);
        }
        const value=controls.querySelector('span');const qty=row.dataset.quantity||'1';
        if(value.textContent!==qty)value.textContent=qty;
      });
    }
    decorateModal() {
      const modal=document.querySelector('.gbbMixVariantModalContainer');if(!modal)return;
      const set=(selector,text)=>{const el=modal.querySelector(selector);if(el&&el.textContent!==text)el.textContent=text;};
      const sizeOptions=[...modal.querySelectorAll('.gbbMixProductVariantOption')].filter(el=>/taille|size/i.test(el.dataset.optionId||''));
      const hasSize=sizeOptions.length>0;
      const normalSizeOption=sizeOptions.find(group=>[...group.querySelectorAll('.gbbMixProductVariantOptionValue')].some(option=>/^\d+$/.test(option.textContent.trim())));
      const hasNormalSize=Boolean(normalSizeOption);
      set('.gbbMixVariantModalTitle',hasSize?'CHOISIS TA TAILLE':'AJOUTE TON BIJOU');
      set('.gbbMixVariantModalQtyHeading','QUANTITÉ');
      if(!modal.querySelector('.gbbMixVariantModalAddBtn svg')) set('.gbbMixVariantModalAddBtn','AJOUTE À TA SÉLECTION');
      const details=modal.querySelector('.gbbMixVariantModalDetailsSection');if(!details)return;
      const title=details.querySelector('.gbbMixVariantModalTitle');
      if(title){title.id||=(this.target?.id||'okan-bundle')+'-variant-title';title.setAttribute('role','heading');title.setAttribute('aria-level','2');modal.setAttribute('aria-labelledby',title.id);}
      modal.querySelector('.gbbMixModalClose')?.setAttribute('aria-label','Fermer');
      modal.querySelector('.gbbMixVariantModalQtyDecrement')?.setAttribute('aria-label','Réduire la quantité');
      modal.querySelector('.gbbMixVariantModalQtyIncrement')?.setAttribute('aria-label','Augmenter la quantité');
      modal.querySelector('.gbbMixVariantModalQtyInput')?.setAttribute('aria-label','Quantité');
      const colour=modal.querySelector('[data-option-id="Couleur"] .gbbMixActiveVariant')?.textContent?.trim();
      if(colour){let metal=details.querySelector('.okan-modal-metal');if(!metal){metal=document.createElement('p');metal.className='okan-modal-metal';details.append(metal);}if(metal.textContent!==colour)metal.textContent=colour;}
      if(hasNormalSize&&!details.querySelector('.okan-modal-guide')){
        const guide=document.createElement('button');guide.type='button';guide.className='okan-modal-guide';guide.textContent='Guide des tailles';guide.setAttribute('aria-haspopup','dialog');
        guide.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();this.openSizeGuide(modal,guide);});normalSizeOption.append(guide);
      }
      if(normalSizeOption){
        normalSizeOption.classList.add('okan-modal-size-option');
        normalSizeOption.setAttribute('role','group');normalSizeOption.setAttribute('aria-label','Taille de bague');
        const label=normalSizeOption.querySelector('.gbbMixProductVariantOptionLabel');if(label&&label.textContent!=='TAILLE')label.textContent='TAILLE';
        const guide=details.querySelector('.okan-modal-guide');if(guide&&guide.parentElement!==normalSizeOption)normalSizeOption.append(guide);
      }
      if(!hasNormalSize) details.querySelector('.okan-modal-guide')?.remove();
      modal.querySelectorAll('.gbbMixProductVariantOptionValue').forEach(option=>{
        option.setAttribute('role','button');option.tabIndex=0;option.setAttribute('aria-pressed',String(option.classList.contains('gbbMixActiveVariant')));
        if(!option.dataset.okanKeyboard){option.dataset.okanKeyboard='true';option.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();option.click();}});}
      });
    }

    openSizeGuide(modal,trigger) {
      if(this.sizeGuide?.open) return;
      const sizes=[...new Set([...modal.querySelectorAll('.gbbMixProductVariantOption')]
        .filter(group=>/taille|size/i.test(group.dataset.optionId||''))
        .flatMap(group=>[...group.querySelectorAll('.gbbMixProductVariantOptionValue')].map(option=>option.textContent.trim()))
        .filter(size=>/^\d+$/.test(size)))].sort((a,b)=>Number(a)-Number(b));
      if(!sizes.length) return;
      const fr=(document.documentElement.lang||'fr').startsWith('fr');
      const t=(f,e)=>fr?f:e;
      const us={46:'3¾',47:'4',48:'4½',49:'4¾',50:'5¼',51:'5¾',52:'6',53:'6¼',54:'6¾',55:'7¼',56:'7½',57:'8',58:'8¼',59:'8¾',60:'9',61:'9½',62:'10'};
      const pdf='https://cdn.shopify.com/s/files/1/0248/2926/3965/files/GUIDE_DE_TAILLE_FR_ENG.pdf?v=1616859084';
      const root=window.Shopify?.routes?.root||'/';
      const contact=new URL(root+'pages/contactez-nous',location.origin).href;
      const dialog=document.createElement('dialog');this.sizeGuide=dialog;
      dialog.className='okan-bundle-size-guide';
      const titleId=(this.target?.id||'okan-bundle')+'-size-guide-title';
      dialog.setAttribute('aria-labelledby',titleId);
      dialog.innerHTML=`<button type="button" class="okr-close" aria-label="${t('Fermer','Close')}">×</button>
        <p class="okr-eyebrow">${t('BESOIN D’AIDE ?','NEED HELP?')}</p>
        <h2 id="${titleId}">${t('GUIDE DE TAILLE','SIZE GUIDE')}</h2>
        <p>${t('Mesure ton tour de doigt avec le','Measure your finger with the')} <a href="${pdf}" target="_blank" rel="noopener">${t('baguier','paper ring sizer')}</a> ${t('imprimé à taille réelle, puis retrouve ta taille ci-dessous.','printed at actual size, then find your size below.')}</p>
        <table><thead><tr><th scope="col">${t('Taille EU','EU size')}</th><th scope="col">${t('Taille US','US size')}</th></tr></thead><tbody>${sizes.map(size=>`<tr><td>${size}</td><td>${us[size]||'—'}</td></tr>`).join('')}</tbody></table>
        <details><summary>${t('Ta taille n’est pas disponible ?','Your size is unavailable?')}</summary><p><a href="${contact}" target="_blank" rel="noopener">${t('Contacte-nous','Contact us')}</a> ${t('pour trouver la solution adaptée à ta taille.','to find the right solution for your size.')}</p></details>
        <button type="button" class="okr-cta">${t('JE CHOISIS MA TAILLE DE BAGUE','CHOOSE MY RING SIZE')}</button>
        <div class="okr-contact"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-6l-5 3v-3H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"/></svg><span>${t('Besoin d’aide ?','Need help?')} <a href="${contact}" target="_blank" rel="noopener">${t('CONTACTE-NOUS','CONTACT US')}</a></span></div>`;
      document.body.append(dialog);
      dialog.querySelector('.okr-close').addEventListener('click',()=>dialog.close());
      dialog.querySelector('.okr-cta').addEventListener('click',()=>dialog.close('choose-size'));
      // Escape closes only this guide, preserving the selected size and quantity underneath.
      dialog.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();event.stopPropagation();dialog.close();}});
      dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
      dialog.addEventListener('close',()=>{
        const focus=dialog.returnValue==='choose-size'
          ? modal.querySelector('.gbbMixProductVariantOption:not([data-option-id="Couleur"]) .gbbMixActiveVariant')||trigger
          : trigger;
        dialog.remove();if(this.sizeGuide===dialog)this.sizeGuide=null;
        if(focus?.isConnected)focus.focus({preventScroll:true});
      },{once:true});
      dialog.showModal();
    }

    decorateComposition() {
      const bundle = this.scope.querySelector('.gbbBundleWrapper');
      if (!bundle) return;
      this.decoratePhotoActions(bundle);
      const fr = (document.documentElement.lang || 'fr').startsWith('fr');
      const grid = bundle.querySelector('.gbbMixProductGrid');
      if (grid && !bundle.querySelector('.okan-composition-heading')) {
        const heading = document.createElement('div');
        heading.className = 'okan-composition-heading';
        const title = document.createElement('h2');
        title.textContent = fr ? 'COMPOSE TON BIJOU' : 'CREATE YOUR COMBINATION';
        heading.append(title);
        grid.before(heading);
      }
      if (grid) {
        const heading = bundle.querySelector('.okan-composition-heading');
        if (heading && grid.previousElementSibling !== heading) grid.before(heading);
        if (this.measuredGrid !== grid) {
          this.gridObserver?.disconnect();
          this.measuredGrid = grid;
          this.gridObserver = new ResizeObserver(() => {
            const width = grid.getBoundingClientRect().width;
            if (width > 0) this.style.setProperty('--okan-grid-width', `${width}px`);
          });
          this.gridObserver.observe(grid);
        }
      }
      const count = Math.max(0, Number(bundle.getAttribute('cart-item-count')) || 0);
      const empty = count === 0;
      const selection = bundle.querySelector('.gbbMixCartDrawerContainer');
      const selectionHadFocus = empty && selection?.contains(document.activeElement);
      bundle.dataset.okanSelectionEmpty = String(empty);
      const headingTitle = bundle.querySelector('.okan-composition-heading h2');
      const drawerToggle = bundle.querySelector('.gbbMixSelectedItemsInCartWrappper');
      const drawer = bundle.querySelector('.gbbMixInlineFooterWrapper');
      // Removing the final item must never leave the composition hidden.
      if (empty && drawer?.getAttribute('data-drawer-status') === 'opened') {
        const nativeDrawer = window.gbb?.components?.cartDrawer?.f;
        if (nativeDrawer?.close) nativeDrawer.close();
        else drawerToggle?.click();
      }
      const drawerOpen = !empty && drawer?.getAttribute('data-drawer-status') === 'opened';
      const selectionItems = selection?.querySelector('.gbbMixCartItemsWrapper');
      if (selectionItems) {
        selectionItems.inert = !drawerOpen;
        selectionItems.setAttribute('aria-hidden', String(!drawerOpen));
      }
      if (headingTitle && grid && drawerToggle) {
        let composeToggle = headingTitle.querySelector('.okan-compose-toggle');
        if (!composeToggle) {
          composeToggle = document.createElement('button');
          composeToggle.type = 'button';
          composeToggle.className = 'okan-compose-toggle';
          composeToggle.textContent = headingTitle.textContent;
          headingTitle.replaceChildren(composeToggle);
          composeToggle.addEventListener('click', () => {
            bundle.querySelector('.gbbMixSelectedItemsInCartWrappper')?.click();
          });
        }
        grid.id ||= `${this.target.id}-choices`;
        composeToggle.disabled = empty;
        composeToggle.setAttribute('aria-controls',grid.id);
        composeToggle.setAttribute('aria-expanded',String(!drawerOpen));
        drawerToggle.setAttribute('aria-expanded',String(drawerOpen));
        // The native drawer keeps its own events and selected products.
        if (!drawerOpen) grid.style.setProperty('--okan-choices-height', `${grid.scrollHeight}px`);
        grid.dataset.collapsed = String(drawerOpen);
        grid.inert = drawerOpen;
      }
      if (selectionHadFocus) bundle.querySelector('.okan-photo-add')?.focus({preventScroll:true});
      // Keep the offer outside both drawers, directly after the purchase row.
      const gaugeAnchor = bundle.querySelector('.gbbMixInlineFooterBtnsWrapper');
      let gauge = bundle.querySelector('.okan-bundle-progress');
      if (!gauge && gaugeAnchor) {
        gauge = document.createElement('div');
        gauge.className = 'okan-bundle-progress';
        const steps = document.createElement('ol');
        steps.className = 'okan-bundle-progress__steps';
        steps.setAttribute('aria-label', fr ? 'Remises selon le nombre de bijoux' : 'Quantity discounts');
        [2,3,4].forEach((threshold, index) => {
          const step = document.createElement('li');
          step.className = 'okan-bundle-progress__step';
          step.dataset.threshold = threshold;
          const label = document.createElement('span');
          label.className = 'okan-bundle-progress__label';
          const quantity = document.createElement('span');
          quantity.className = 'okan-bundle-progress__quantity';
          quantity.textContent = fr ? (threshold === 4 ? '4 et +' : `${threshold} bijoux`) : `${threshold}${threshold === 4 ? '+' : ''} pieces`;
          const separator = document.createElement('span');
          separator.className = 'okan-bundle-progress__separator';
          separator.textContent = '·';
          separator.setAttribute('aria-hidden','true');
          const discount = document.createElement('span');
          discount.className = 'okan-bundle-progress__discount';
          discount.textContent = `−${10 + index * 5} %`;
          label.append(quantity, separator, discount);
          step.append(label);
          steps.append(step);
        });
        const message = document.createElement('p');
        message.className = 'okan-bundle-progress__message';
        message.setAttribute('role','status');
        message.setAttribute('aria-live','polite');
        gauge.append(steps, message);
        gaugeAnchor.after(gauge);
      }
      if (gauge) {
      if (gaugeAnchor && gauge.previousElementSibling !== gaugeAnchor) gaugeAnchor.after(gauge);
      gauge.querySelectorAll('[data-threshold]').forEach(step => {
        step.dataset.reached = String(count >= Number(step.dataset.threshold));
      });
      const remaining = count < 2 ? 2 - count : 1;
      const nextDiscount = count < 2 ? 10 : count === 2 ? 15 : 20;
      const progressText = count >= 4
        ? (fr ? '−20 % sur ta composition' : '20% off your selection')
        : (fr ? `Encore ${remaining} bijou${remaining > 1 ? 'x' : ''} pour bénéficier de −${nextDiscount} %` : `Add ${remaining} more piece${remaining > 1 ? 's' : ''} for ${nextDiscount}% off`);
      const progressMessage = gauge.querySelector('.okan-bundle-progress__message');
      if (progressMessage.textContent !== progressText) progressMessage.textContent = progressText;
      }
      const toggle = bundle.querySelector('.gbbMixSelectedItemsInCartWrappper');
      if (toggle) {
        const label = toggle.querySelector('.gbbMixCartDrawerBtnText');
        const text = fr ? 'TA SÉLECTION' : 'YOUR SELECTION';
        if (label && label.textContent !== text) label.textContent = text;
        let counter = toggle.querySelector('.okan-composition-count');
        if (!counter) {
          counter = document.createElement('span');
          counter.className = 'okan-composition-count';
          counter.setAttribute('aria-live','polite');
          toggle.append(counter);
        }
        const countText = fr ? `${count} bijou${count > 1 ? 'x' : ''}` : `${count} item${count === 1 ? '' : 's'}`;
        if (counter.textContent !== countText) counter.textContent = countText;
      }
      bundle.querySelectorAll('.okan-composition-empty').forEach(node => node.remove());
      // Derive the short material from the app's existing product title.
      bundle.querySelectorAll('.gbbMixProductCard').forEach(card => {
        const content = card.querySelector('.gbbMixProductCardContent');
        if (!content || card.querySelector('.gbbMixProductCardVariantLabel')) return;
        const source = card.querySelector('.gbbMixProductCardTitle');
        const name = source?.getAttribute('title') || source?.textContent || card.querySelector('img')?.alt || '';
        let material = '';
        if (/argent.*noir|black.*silver/i.test(name)) material = fr ? 'Argent Noir' : 'Black Silver';
        else if (/argent|silver/i.test(name)) material = fr ? 'Argent 925' : 'Sterling Silver';
        else if (/laiton|brass/i.test(name)) material = fr ? 'Laiton Or Jaune' : 'Gold-plated Brass';
        if (!material) return;
        let label = content.querySelector('.okan-composition-metal');
        if (!label) {
          label = document.createElement('div');
          label.className = 'okan-composition-metal';
          content.prepend(label);
        }
        if (label.textContent !== material) label.textContent = material;
      });
      bundle.querySelectorAll('.gbbMixBundleCartItem').forEach(item => {
        const button = item.querySelector('.gbbMixBundleCartItemRemoveBtn');
        const detail = item.querySelector('.gbbMixCartItemVariantTitle')?.textContent || item.querySelector('.gbbMixCartItemTitle')?.textContent || '';
        const label = `${fr ? 'Retirer' : 'Remove'} ${detail.trim()}`;
        if (button && button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      });
      const formButtons = bundle.closest('.product-form-buttons');
      const cta = bundle.querySelector('.gbbMixInlineAddToCartBtn');
      const ctaLabel = cta?.querySelector('.gbbMixInlineAddToCartBtnLabel');
      const ctaText = fr ? 'FINALISE TA SÉLECTION' : 'FINALISE YOUR SELECTION';
      if (ctaLabel && ctaLabel.textContent !== ctaText) ctaLabel.textContent = ctaText;
      if (cta && (this.alignedCTA !== cta || this.alignedForm !== formButtons)) {
        this.ctaObserver?.disconnect();
        this.purchaseStyleObserver?.disconnect();
        this.alignedCTA = cta;
        this.alignedForm = formButtons;
        this.alignPurchaseRow = () => {
          if (!cta.isConnected) return;
          const rect = cta.getBoundingClientRect();
          if (!rect.width) return;
          const setVariable = (node, name, value) => {
            if (node.style.getPropertyValue(name) !== value) node.style.setProperty(name, value);
          };
          const offer = bundle.querySelector('.okan-bundle-progress');
          if (offer) {
            const parent = offer.parentElement;
            const parentRect = parent.getBoundingClientRect();
            const parentStyle = getComputedStyle(parent);
            const contentLeft = parentRect.left + (parseFloat(parentStyle.borderLeftWidth) || 0) + (parseFloat(parentStyle.paddingLeft) || 0);
            setVariable(offer, '--okan-cta-width', `${rect.width}px`);
            setVariable(offer, '--okan-cta-offset', `${Math.max(0, rect.left - contentLeft)}px`);
          }
          // Set the anchor even before Wishlist King inserts its button.
          if (formButtons) {
            const formRect = formButtons.getBoundingClientRect();
            const border = parseFloat(getComputedStyle(formButtons).borderTopWidth) || 0;
            const y = rect.top - formRect.top - border + formButtons.scrollTop;
            setVariable(formButtons, '--okan-wishlist-top', `${y}px`);
          }
        };
        this.ctaObserver = new ResizeObserver(this.alignPurchaseRow);
        this.ctaObserver.observe(bundle);
        this.ctaObserver.observe(cta);
        if (grid) this.ctaObserver.observe(grid);
        if (selection) this.ctaObserver.observe(selection);
        if (formButtons) {
          // The theme may replace the form's inline spacing styles after rendering.
          this.purchaseStyleObserver = new MutationObserver(this.alignPurchaseRow);
          this.purchaseStyleObserver.observe(formButtons, {attributes:true, attributeFilter:['style']});
        }
      }
      this.alignPurchaseRow?.();
    }
    cents(text) {
      let value = (text || '').replace(/[^\d.,-]/g, '');
      if (!value) return null;
      const decimal = value.match(/[.,](\d{1,2})$/);
      if (decimal) {
        const index = value.length - decimal[0].length;
        value = value.slice(0,index).replace(/[.,]/g,'') + '.' + decimal[1];
      } else value = value.replace(/[.,]/g,'');
      const number = Number(value);
      return Number.isFinite(number) && number >= 0 ? Math.round(number * 100) : null;
    }
    sync() {
      if (!this.isConnected) return;
      this.decorateComposition();
      const nativeTotal = this.scope.querySelector('.gbbMixNativeProductPagePrice__totalPrice');
      const source = nativeTotal || this.scope.querySelector('.gbbMixInlineDiscountedPriceValue');
      const amount = this.cents(source?.textContent);
      const hasSelection = amount !== null && amount > 0;
      const format = value => new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency', currency:window.Shopify?.currency?.active || 'EUR'}).format(value / 100);
      const label = hasSelection ? format(amount) : `${this.dataset.from} ${this.dataset.startPrice}`;
      if (this.total.textContent !== label) this.total.textContent = label;
      const strike = this.scope.querySelector('.gbbMixNativeProductPagePrice__compareAtPrice') || this.scope.querySelector('.gbbMixInlineStrikeThroughPriceValue');
      const compareText = hasSelection && this.cents(strike?.textContent) > amount ? format(this.cents(strike.textContent)) : '';
      if (this.compare.textContent !== compareText) this.compare.textContent = compareText;
      this.compare.hidden = !compareText;
      const purchaseAmount = hasSelection ? amount : (this.cents(this.dataset.startPrice) || 0);
      if (window.Shopify?.currency?.active && window.Shopify.currency.active !== 'EUR') return;
      // A legacy v3 script also exists on this theme. Wait until the official
      // v4 app has actually rendered before initializing the bundle instance.
      if (!this.scope.querySelector('#alma-widget .alma-payment-plans-container')) return;
      if (!window.Alma?.Widgets || !window.ALMA_MERCHANT_ID || !window.ALMA_FEE_PLANS) return;
      // v3 can overwrite window.Alma AFTER the official v4 widget rendered.
      // Capture a fresh v4 reference once and never consult that global again.
      if (!this.almaLibrary) {
        if (!this.loadingLibrary) {
          this.loadingLibrary = true;
          window.okanBundleAlmaV4Promise ||= new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/@alma/widgets@4.x.x/dist/widgets.umd.js';
            script.onload = () => window.Alma?.Widgets ? resolve(window.Alma) : reject(new Error('Alma v4 unavailable'));
            script.onerror = () => reject(new Error('Alma v4 could not load'));
            document.head.appendChild(script);
          });
          window.okanBundleAlmaV4Promise.then(library => {
            this.almaLibrary = library;
            this.lastAmount = null;
            if (this.isConnected) this.sync();
          }).catch(error => console.warn('ŌKAN Alma', error));
        }
        return;
      }
      if (purchaseAmount === this.lastAmount) return;
      try {
        const config = typeof window.ALMA_FEE_PLANS === 'string' ? JSON.parse(window.ALMA_FEE_PLANS) : window.ALMA_FEE_PLANS;
        const plans = Object.entries(config).flatMap(([key, plan]) => {
          const match = key.match(/_(\d+)_(\d+)_(\d+)$/);
          if (!match || ![true,'True','true'].includes(plan.is_enabled)) return [];
          return [{installmentsCount:Number(match[1]),deferredDays:Number(match[2]),deferredMonth:Number(match[3]),minAmount:plan.min_amount,maxAmount:plan.max_amount}];
        });
        if (!plans.length) return;
        this.widget ||= this.almaLibrary.Widgets.initialize(window.ALMA_MERCHANT_ID, this.almaLibrary.ApiMode.LIVE);
        this.widget.add(this.almaLibrary.Widgets.PaymentPlans, {
          container:'#'+this.target.id,
          locale:window.ALMA_LOCALE || document.documentElement.lang || 'fr',
          purchaseAmount,
          hideIfNotEligible:false,
          plans,
          monochrome:true
        });
        this.lastAmount = purchaseAmount;
        clearInterval(this.retry);
      } catch (error) {
        console.warn('ŌKAN : mise à jour Alma du bundle indisponible.', error);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["okan-earcuff-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('okan-earcuff-bundle')) {
  customElements.define('okan-earcuff-bundle', class extends HTMLElement {
    connectedCallback() {
      // Wait for the element children to finish parsing before reading them.
      this.startFrame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected) return;
      this.scope = this.closest('.product-details');
      if (!this.scope) return;
      this.total = this.querySelector('[data-bundle-total]');
      this.compare = this.querySelector('[data-bundle-compare]');
      this.target = this.querySelector('.okan-earcuff-bundle__alma');
      this.lastAmount = null;
      this.observer?.disconnect();
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.sync();
      });
      this.observer.observe(this.scope, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:["cart-item-count","data-drawer-status"]});
      this.sync();
      // The official app and its library load asynchronously.
      this.retry = setInterval(() => this.sync(), 500);
      this.stopRetry = setTimeout(() => clearInterval(this.retry), 60000);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      this.gridObserver?.disconnect();
      this.ctaObserver?.disconnect();
      this.purchaseStyleObserver?.disconnect();
      this.alignedCTA = null;
      this.alignedForm = null;
      this.alignPurchaseRow = null;
      this.measuredGrid = null;
      this.observer?.disconnect();
      clearInterval(this.retry);
      clearTimeout(this.stopRetry);
    }

    decoratePhotoActions(bundle) {
      bundle.querySelectorAll('.gbbMixProductCard').forEach(card => {
        const wrap=card.querySelector('.gbbMixProductCardImageWrapper');
        if(!wrap) return;
        let add=wrap.querySelector('.okan-photo-add');
        if(!add){
          add=document.createElement('button');add.type='button';add.className='okan-photo-add';add.textContent='+';
          add.addEventListener('click',event=>{
            event.preventDefault();event.stopPropagation();
            if(card.dataset.isMultiVariant==='true') card.querySelector('.gbbMixProductCardImage')?.click();
            else card.querySelector('.gbbMixProductCardAddBtn,.gbbMixProductCardQtyIncrement')?.click();
          });wrap.append(add);
        }
        let badge=wrap.querySelector('.okan-photo-count');
        if(!badge){badge=document.createElement('span');badge.className='okan-photo-count';wrap.append(badge);}
        // Easy Bundle tracks each single-variant earcuff card independently.
        // All three metals share one product ID: never sum them by product ID.
        const count=Math.max(0,Number(card.dataset.productQuantity)||0);
        const material=card.querySelector('.gbbMixProductCardVariantLabel')?.textContent?.trim()||'';
        const fr=(document.documentElement.lang||'fr').startsWith('fr');
        const addLabel=(fr?'Ajouter ce bijou':'Add this piece')+(material?' — '+material:'');
        if(add.getAttribute('aria-label')!==addLabel)add.setAttribute('aria-label',addLabel);
        if(badge.textContent!==String(count)) badge.textContent=String(count);
        badge.hidden=count===0;badge.setAttribute('aria-label',fr?`${count} bijou${count>1?'x':''} sélectionné${count>1?'s':''}`:`${count} selected`);
      });
      bundle.querySelectorAll('.gbbMixBundleCartItem').forEach(row=>{
        const right=row.querySelector('.gbbMixBundleCartItemRightSec');
        if(!right || !window.gbb?.sdk?.f?.updateCartItem) return;
        const remove=right.querySelector('.gbbMixBundleCartItemRemoveBtn');
        if(remove&&!remove.dataset.okanBound){
          remove.dataset.okanBound='true';
          remove.addEventListener('click',event=>{
            event.preventDefault();event.stopImmediatePropagation();
            window.gbb.sdk.f.updateCartItem(row.dataset.uniqueId,{updateQuantityBy:-(Number(row.dataset.quantity)||1),showToast:true});
          },true);
        }
        let controls=right.querySelector('.okan-earcuff-quantity');
        if(!controls){
          controls=document.createElement('div');controls.className='okan-earcuff-quantity';
          const value=document.createElement('span');value.setAttribute('aria-live','polite');
          [-1,1].forEach(delta=>{
            const button=document.createElement('button');button.type='button';button.textContent=delta<0?'−':'+';
            button.setAttribute('aria-label',(delta<0?'Réduire':'Augmenter')+' la quantité de ce bijou');
            button.addEventListener('click',async event=>{
              event.preventDefault();event.stopPropagation();
              if(controls.dataset.busy==='true') return;
              controls.dataset.busy='true';controls.querySelectorAll('button').forEach(b=>b.disabled=true);
              try {await window.gbb.sdk.f.updateCartItem(row.dataset.uniqueId,{updateQuantityBy:delta,showToast:true});}
              finally {controls.dataset.busy='false';controls.querySelectorAll('button').forEach(b=>b.disabled=false);this.sync();}
            });controls.append(button);if(delta<0)controls.append(value);
          });right.prepend(controls);
        }
        const value=controls.querySelector('span');const qty=row.dataset.quantity||'1';
        if(value.textContent!==qty)value.textContent=qty;
      });
    }
    decorateComposition() {
      const bundle = this.scope.querySelector('.gbbBundleWrapper');
      if (!bundle) return;
      this.decoratePhotoActions(bundle);
      const fr = (document.documentElement.lang || 'fr').startsWith('fr');
      const grid = bundle.querySelector('.gbbMixProductGrid');
      if (grid && !bundle.querySelector('.okan-composition-heading')) {
        const heading = document.createElement('div');
        heading.className = 'okan-composition-heading';
        const title = document.createElement('h2');
        title.textContent = fr ? 'COMPOSE TON BIJOU' : 'CREATE YOUR COMBINATION';
        heading.append(title);
        grid.before(heading);
      }
      if (grid) {
        const heading = bundle.querySelector('.okan-composition-heading');
        if (heading && grid.previousElementSibling !== heading) grid.before(heading);
        if (this.measuredGrid !== grid) {
          this.gridObserver?.disconnect();
          this.measuredGrid = grid;
          this.gridObserver = new ResizeObserver(() => {
            const width = grid.getBoundingClientRect().width;
            if (width > 0) this.style.setProperty('--okan-grid-width', `${width}px`);
          });
          this.gridObserver.observe(grid);
        }
      }
      const count = Math.max(0, Number(bundle.getAttribute('cart-item-count')) || 0);
      const empty = count === 0;
      const selection = bundle.querySelector('.gbbMixCartDrawerContainer');
      const selectionHadFocus = empty && selection?.contains(document.activeElement);
      bundle.dataset.okanSelectionEmpty = String(empty);
      const headingTitle = bundle.querySelector('.okan-composition-heading h2');
      const drawerToggle = bundle.querySelector('.gbbMixSelectedItemsInCartWrappper');
      const drawer = bundle.querySelector('.gbbMixInlineFooterWrapper');
      // Removing the final item must never leave the composition hidden.
      if (empty && drawer?.getAttribute('data-drawer-status') === 'opened') {
        const nativeDrawer = window.gbb?.components?.cartDrawer?.f;
        if (nativeDrawer?.close) nativeDrawer.close();
        else drawerToggle?.click();
      }
      const drawerOpen = !empty && drawer?.getAttribute('data-drawer-status') === 'opened';
      const selectionItems = selection?.querySelector('.gbbMixCartItemsWrapper');
      if (selectionItems) {
        selectionItems.inert = !drawerOpen;
        selectionItems.setAttribute('aria-hidden', String(!drawerOpen));
      }
      if (headingTitle && grid && drawerToggle) {
        let composeToggle = headingTitle.querySelector('.okan-compose-toggle');
        if (!composeToggle) {
          composeToggle = document.createElement('button');
          composeToggle.type = 'button';
          composeToggle.className = 'okan-compose-toggle';
          composeToggle.textContent = headingTitle.textContent;
          headingTitle.replaceChildren(composeToggle);
          composeToggle.addEventListener('click', () => {
            bundle.querySelector('.gbbMixSelectedItemsInCartWrappper')?.click();
          });
        }
        grid.id ||= `${this.target.id}-choices`;
        composeToggle.disabled = empty;
        composeToggle.setAttribute('aria-controls',grid.id);
        composeToggle.setAttribute('aria-expanded',String(!drawerOpen));
        drawerToggle.setAttribute('aria-expanded',String(drawerOpen));
        // The native drawer keeps its own events and selected products.
        if (!drawerOpen) grid.style.setProperty('--okan-choices-height', `${grid.scrollHeight}px`);
        grid.dataset.collapsed = String(drawerOpen);
        grid.inert = drawerOpen;
      }
      if (selectionHadFocus) bundle.querySelector('.okan-photo-add')?.focus({preventScroll:true});
      // Keep the offer outside both drawers, directly after the purchase row.
      const gaugeAnchor = bundle.querySelector('.gbbMixInlineFooterBtnsWrapper');
      let gauge = bundle.querySelector('.okan-bundle-progress');
      if (!gauge && gaugeAnchor) {
        gauge = document.createElement('div');
        gauge.className = 'okan-bundle-progress';
        const steps = document.createElement('ol');
        steps.className = 'okan-bundle-progress__steps';
        steps.setAttribute('aria-label', fr ? 'Remises selon le nombre de bijoux' : 'Quantity discounts');
        [2,3,4].forEach((threshold, index) => {
          const step = document.createElement('li');
          step.className = 'okan-bundle-progress__step';
          step.dataset.threshold = threshold;
          const label = document.createElement('span');
          label.className = 'okan-bundle-progress__label';
          const quantity = document.createElement('span');
          quantity.className = 'okan-bundle-progress__quantity';
          quantity.textContent = fr ? (threshold === 4 ? '4 et +' : `${threshold} bijoux`) : `${threshold}${threshold === 4 ? '+' : ''} pieces`;
          const separator = document.createElement('span');
          separator.className = 'okan-bundle-progress__separator';
          separator.textContent = '·';
          separator.setAttribute('aria-hidden','true');
          const discount = document.createElement('span');
          discount.className = 'okan-bundle-progress__discount';
          discount.textContent = `−${10 + index * 5} %`;
          label.append(quantity, separator, discount);
          step.append(label);
          steps.append(step);
        });
        const message = document.createElement('p');
        message.className = 'okan-bundle-progress__message';
        message.setAttribute('role','status');
        message.setAttribute('aria-live','polite');
        gauge.append(steps, message);
        gaugeAnchor.after(gauge);
      }
      if (gauge) {
      if (gaugeAnchor && gauge.previousElementSibling !== gaugeAnchor) gaugeAnchor.after(gauge);
      gauge.querySelectorAll('[data-threshold]').forEach(step => {
        step.dataset.reached = String(count >= Number(step.dataset.threshold));
      });
      const remaining = count < 2 ? 2 - count : 1;
      const nextDiscount = count < 2 ? 10 : count === 2 ? 15 : 20;
      const progressText = count >= 4
        ? (fr ? '−20 % sur ta composition' : '20% off your selection')
        : (fr ? `Encore ${remaining} bijou${remaining > 1 ? 'x' : ''} pour bénéficier de −${nextDiscount} %` : `Add ${remaining} more piece${remaining > 1 ? 's' : ''} for ${nextDiscount}% off`);
      const progressMessage = gauge.querySelector('.okan-bundle-progress__message');
      if (progressMessage.textContent !== progressText) progressMessage.textContent = progressText;
      }
      const toggle = bundle.querySelector('.gbbMixSelectedItemsInCartWrappper');
      if (toggle) {
        const label = toggle.querySelector('.gbbMixCartDrawerBtnText');
        const text = fr ? 'TA SÉLECTION' : 'YOUR SELECTION';
        if (label && label.textContent !== text) label.textContent = text;
        let counter = toggle.querySelector('.okan-composition-count');
        if (!counter) {
          counter = document.createElement('span');
          counter.className = 'okan-composition-count';
          counter.setAttribute('aria-live','polite');
          toggle.append(counter);
        }
        const countText = fr ? `${count} bijou${count > 1 ? 'x' : ''}` : `${count} item${count === 1 ? '' : 's'}`;
        if (counter.textContent !== countText) counter.textContent = countText;
      }
      bundle.querySelectorAll('.okan-composition-empty').forEach(node => node.remove());
      // Derive the short material from the app's existing product title.
      bundle.querySelectorAll('.gbbMixProductCard').forEach(card => {
        const content = card.querySelector('.gbbMixProductCardContent');
        if (!content || card.querySelector('.gbbMixProductCardVariantLabel')) return;
        const source = card.querySelector('.gbbMixProductCardTitle');
        const name = source?.getAttribute('title') || source?.textContent || card.querySelector('img')?.alt || '';
        let material = '';
        if (/argent.*noir|black.*silver/i.test(name)) material = fr ? 'Argent Noir' : 'Black Silver';
        else if (/argent|silver/i.test(name)) material = fr ? 'Argent 925' : 'Sterling Silver';
        else if (/laiton|brass/i.test(name)) material = fr ? 'Laiton Or Jaune' : 'Gold-plated Brass';
        if (!material) return;
        let label = content.querySelector('.okan-composition-metal');
        if (!label) {
          label = document.createElement('div');
          label.className = 'okan-composition-metal';
          content.prepend(label);
        }
        if (label.textContent !== material) label.textContent = material;
      });
      bundle.querySelectorAll('.gbbMixBundleCartItem').forEach(item => {
        const button = item.querySelector('.gbbMixBundleCartItemRemoveBtn');
        const detail = item.querySelector('.gbbMixCartItemVariantTitle')?.textContent || item.querySelector('.gbbMixCartItemTitle')?.textContent || '';
        const label = `${fr ? 'Retirer' : 'Remove'} ${detail.trim()}`;
        if (button && button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      });
      const formButtons = bundle.closest('.product-form-buttons');
      const cta = bundle.querySelector('.gbbMixInlineAddToCartBtn');
      const ctaLabel = cta?.querySelector('.gbbMixInlineAddToCartBtnLabel');
      const ctaText = fr ? 'FINALISE TA SÉLECTION' : 'FINALISE YOUR SELECTION';
      if (ctaLabel && ctaLabel.textContent !== ctaText) ctaLabel.textContent = ctaText;
      if (cta && (this.alignedCTA !== cta || this.alignedForm !== formButtons)) {
        this.ctaObserver?.disconnect();
        this.purchaseStyleObserver?.disconnect();
        this.alignedCTA = cta;
        this.alignedForm = formButtons;
        this.alignPurchaseRow = () => {
          if (!cta.isConnected) return;
          const rect = cta.getBoundingClientRect();
          if (!rect.width) return;
          const setVariable = (node, name, value) => {
            if (node.style.getPropertyValue(name) !== value) node.style.setProperty(name, value);
          };
          const offer = bundle.querySelector('.okan-bundle-progress');
          if (offer) {
            const parent = offer.parentElement;
            const parentRect = parent.getBoundingClientRect();
            const parentStyle = getComputedStyle(parent);
            const contentLeft = parentRect.left + (parseFloat(parentStyle.borderLeftWidth) || 0) + (parseFloat(parentStyle.paddingLeft) || 0);
            setVariable(offer, '--okan-cta-width', `${rect.width}px`);
            setVariable(offer, '--okan-cta-offset', `${Math.max(0, rect.left - contentLeft)}px`);
          }
          // Set the anchor even before Wishlist King inserts its button.
          if (formButtons) {
            const formRect = formButtons.getBoundingClientRect();
            const border = parseFloat(getComputedStyle(formButtons).borderTopWidth) || 0;
            const y = rect.top - formRect.top - border + formButtons.scrollTop;
            setVariable(formButtons, '--okan-wishlist-top', `${y}px`);
          }
        };
        this.ctaObserver = new ResizeObserver(this.alignPurchaseRow);
        this.ctaObserver.observe(bundle);
        this.ctaObserver.observe(cta);
        if (grid) this.ctaObserver.observe(grid);
        if (selection) this.ctaObserver.observe(selection);
        if (formButtons) {
          // The theme may replace the form's inline spacing styles after rendering.
          this.purchaseStyleObserver = new MutationObserver(this.alignPurchaseRow);
          this.purchaseStyleObserver.observe(formButtons, {attributes:true, attributeFilter:['style']});
        }
      }
      this.alignPurchaseRow?.();
    }
    cents(text) {
      let value = (text || '').replace(/[^\d.,-]/g, '');
      if (!value) return null;
      const decimal = value.match(/[.,](\d{1,2})$/);
      if (decimal) {
        const index = value.length - decimal[0].length;
        value = value.slice(0,index).replace(/[.,]/g,'') + '.' + decimal[1];
      } else value = value.replace(/[.,]/g,'');
      const number = Number(value);
      return Number.isFinite(number) && number >= 0 ? Math.round(number * 100) : null;
    }
    sync() {
      if (!this.isConnected) return;
      this.decorateComposition();
      const nativeTotal = this.scope.querySelector('.gbbMixNativeProductPagePrice__totalPrice');
      const source = nativeTotal || this.scope.querySelector('.gbbMixInlineDiscountedPriceValue');
      const amount = this.cents(source?.textContent);
      const hasSelection = amount !== null && amount > 0;
      const format = value => new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency', currency:window.Shopify?.currency?.active || 'EUR'}).format(value / 100);
      const label = hasSelection ? format(amount) : `${this.dataset.from} ${this.dataset.startPrice}`;
      if (this.total.textContent !== label) this.total.textContent = label;
      const strike = this.scope.querySelector('.gbbMixNativeProductPagePrice__compareAtPrice') || this.scope.querySelector('.gbbMixInlineStrikeThroughPriceValue');
      const compareText = hasSelection && this.cents(strike?.textContent) > amount ? format(this.cents(strike.textContent)) : '';
      if (this.compare.textContent !== compareText) this.compare.textContent = compareText;
      this.compare.hidden = !compareText;
      const purchaseAmount = hasSelection ? amount : (this.cents(this.dataset.startPrice) || 0);
      if (window.Shopify?.currency?.active && window.Shopify.currency.active !== 'EUR') return;
      // A legacy v3 script also exists on this theme. Wait until the official
      // v4 app has actually rendered before initializing the bundle instance.
      if (!this.scope.querySelector('#alma-widget .alma-payment-plans-container')) return;
      if (!window.Alma?.Widgets || !window.ALMA_MERCHANT_ID || !window.ALMA_FEE_PLANS) return;
      // v3 can overwrite window.Alma AFTER the official v4 widget rendered.
      // Capture a fresh v4 reference once and never consult that global again.
      if (!this.almaLibrary) {
        if (!this.loadingLibrary) {
          this.loadingLibrary = true;
          window.okanBundleAlmaV4Promise ||= new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/@alma/widgets@4.x.x/dist/widgets.umd.js';
            script.onload = () => window.Alma?.Widgets ? resolve(window.Alma) : reject(new Error('Alma v4 unavailable'));
            script.onerror = () => reject(new Error('Alma v4 could not load'));
            document.head.appendChild(script);
          });
          window.okanBundleAlmaV4Promise.then(library => {
            this.almaLibrary = library;
            this.lastAmount = null;
            if (this.isConnected) this.sync();
          }).catch(error => console.warn('ŌKAN Alma', error));
        }
        return;
      }
      if (purchaseAmount === this.lastAmount) return;
      try {
        const config = typeof window.ALMA_FEE_PLANS === 'string' ? JSON.parse(window.ALMA_FEE_PLANS) : window.ALMA_FEE_PLANS;
        const plans = Object.entries(config).flatMap(([key, plan]) => {
          const match = key.match(/_(\d+)_(\d+)_(\d+)$/);
          if (!match || ![true,'True','true'].includes(plan.is_enabled)) return [];
          return [{installmentsCount:Number(match[1]),deferredDays:Number(match[2]),deferredMonth:Number(match[3]),minAmount:plan.min_amount,maxAmount:plan.max_amount}];
        });
        if (!plans.length) return;
        this.widget ||= this.almaLibrary.Widgets.initialize(window.ALMA_MERCHANT_ID, this.almaLibrary.ApiMode.LIVE);
        this.widget.add(this.almaLibrary.Widgets.PaymentPlans, {
          container:'#'+this.target.id,
          locale:window.ALMA_LOCALE || document.documentElement.lang || 'fr',
          purchaseAmount,
          hideIfNotEligible:false,
          plans,
          monochrome:true
        });
        this.lastAmount = purchaseAmount;
        clearInterval(this.retry);
      } catch (error) {
        console.warn('ŌKAN : mise à jour Alma du bundle indisponible.', error);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["okan-earcuff-tutorial"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element
      ? event.target.closest('[data-okan-earcuff-tutorial]') : null;
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    if (document.querySelector('.okan-earcuff-tutorial-dialog[open]')) return;
    const template = trigger.closest('.okan-earcuff-tutorial')?.querySelector('template');
    const dialog = template?.content.querySelector('dialog')?.cloneNode(true);
    if (!dialog) return;
    document.body.appendChild(dialog);
    const video = dialog.querySelector('video');
    const overflow = document.documentElement.style.overflow;
    dialog.addEventListener('close', () => {
      video?.pause();
      dialog.remove();
      document.documentElement.style.overflow = overflow;
      if (trigger.isConnected) trigger.focus({ preventScroll: true });
    }, { once: true });
    dialog.querySelector('.okan-earcuff-tutorial-dialog__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (click) => {
      if (click.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (click.clientX < bounds.left || click.clientX > bounds.right ||
          click.clientY < bounds.top || click.clientY > bounds.bottom) dialog.close();
    });
    dialog.querySelector('.okan-earcuff-tutorial-return').addEventListener('click',()=>dialog.close());
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    // The file is only requested when the visitor opens the tutorial.
    if (video) {
      video.muted = true;
      video.playsInline = true;
      video.preload = 'auto';
      video.load();
      // Start during the opening click; native controls remain available.
      const playback = video.play();
      if (playback) playback.catch(() => {
        // If playback is blocked or the dialog closes while loading,
        // keep manual playback available without an unhandled rejection.
      });
    }
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["okan-product-services"] && !Shopify.designMode) return;
  try {
    // One open product-details drawer per product; delegated for theme-editor refreshes.
  document.addEventListener('toggle', (event) => {
    const opened = event.target;
    if (!(opened instanceof HTMLDetailsElement) || !opened.open ||
        !opened.matches('.accordion > accordion-custom > details.details')) return;
    const product = opened.closest('.product-details');
    if (!product || !product.querySelector('[data-okan-exclusive-details], okan-bundle-price')) return;
    product.querySelectorAll('.accordion > accordion-custom > details.details[open]').forEach((other) => {
      if (other !== opened) other.open = false;
    });
  }, true);

  // Delegation also handles blocks re-rendered by the Shopify theme editor.
  document.addEventListener('click', async (event) => {
    const link = event.target instanceof Element
      ? event.target.closest('a[data-okan-open-inbox]')
      : null;
    if (!link || event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    event.stopPropagation();
    if (link.dataset.inboxPending === 'true') return;
    link.dataset.inboxPending = 'true';
    link.setAttribute('aria-busy', 'true');
    const fallbackUrl = link.href;

    const findLauncher = (root) => {
      if (!root) return null;
      const button = root.querySelector('button.activator, button[aria-controls="chat-window"], button[aria-controls="ShopifyChat"]');
      if (button) return button;
      for (const element of root.querySelectorAll('*')) {
        if (element.shadowRoot) {
          const found = findLauncher(element.shadowRoot);
          if (found) return found;
        }
        if (element.tagName === 'IFRAME') {
          try { const found = findLauncher(element.contentDocument); if (found) return found; } catch (_) {}
        }
      }
      return null;
    };
    const openChat = () => {
      for (const chat of document.querySelectorAll('shopify-chat, #ShopifyChat, #shopify-chat')) {
        if (typeof chat.show === 'function') { chat.show(); return true; }
        const launcher = findLauncher(chat.shadowRoot) || findLauncher(chat);
        if (!launcher || launcher.disabled) continue;
        if (launcher.getAttribute('aria-expanded') !== 'true') launcher.click();
        return true;
      }
      return false;
    };

    try {
      // Finish the original outside click before showing the chat.
      await new Promise(resolve => setTimeout(resolve, 0));
      // Allow the native widget a short time to finish loading on a first visit.
      for (let attempt = 0; attempt <= 20; attempt += 1) {
        if (openChat()) return;
        if (attempt < 20) await new Promise(resolve => setTimeout(resolve, 100));
      }
      window.location.assign(fallbackUrl);
    } finally {
      delete link.dataset.inboxPending;
      link.removeAttribute('aria-busy');
    }
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["packshot-interactif"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('okan-packshot-interactif')) return;
  customElements.define('okan-packshot-interactif', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (this.controller || !this.isConnected) return;
      this.video = this.querySelector('video');
      this.surface = this.querySelector('[data-surface]');
      this.status = this.querySelector('[data-status]');
      if (!this.video || !this.surface) return;
      this.controller = new AbortController();
      this.pending = false;
      this.resume = false;
      this.visible = false;
      this.started = false;
      delete this.dataset.frameReady;
      this.video.controls = false;
      this.video.muted = true;
      this.video.loop = this.dataset.wrap === 'true';
      const on = (target, type, fn) => target.addEventListener(type, fn, { signal: this.controller.signal });
      on(this.video, 'loadedmetadata', () => this.ready());
      on(this.video, 'loadeddata', () => this.reveal());
      on(this.video, 'canplay', () => this.reveal());
      on(this.video, 'durationchange', () => this.ready());
      on(this.video, 'seeked', () => {
        if (this.pending) this.seek();
        else if (this.resume) this.play();
      });
      on(this.video, 'error', () => {
        this.resume = false;
        this.status.textContent = 'Cette vidéo ne peut pas être chargée.';
      });
      on(this.surface, 'pointerdown', e => {
        if (!e.isPrimary || e.button !== 0 || !this.end) return;
        this.resume = false;
        this.drag = { id: e.pointerId, x: e.clientX, y: e.clientY, time: this.video.currentTime, active: false };
      });
      on(this.surface, 'pointermove', e => this.move(e));
      on(this.surface, 'pointerup', e => {
        if (!this.drag || this.drag.id !== e.pointerId) return;
        const active = this.drag.active;
        if (active) this.move(e);
        this.stopDrag();
        if (active) {
          this.resume = this.dataset.resume === 'true';
          if (this.resume && !this.pending && !this.video.seeking) this.play();
        } else if (this.video.paused) this.play();
        else this.video.pause();
      });
      for (const type of ['pointercancel', 'lostpointercapture']) {
        on(this.surface, type, () => this.stopDrag());
      }
      on(this.surface, 'pointerleave', () => {
        if (this.drag && !this.drag.active) this.stopDrag();
      });
      on(this.surface, 'keydown', e => {
        if (!['ArrowLeft', 'ArrowRight', ' ', 'Home', 'End'].includes(e.key)) return;
        e.preventDefault();
        this.resume = false;
        if (e.key === ' ') {
          if (this.video.paused) this.play();
          else this.video.pause();
          return;
        }
        if (!this.end) return;
        this.video.pause();
        this.target = e.key === 'Home' ? 0 : e.key === 'End' ? this.end
          : Math.max(0, Math.min(this.end, this.video.currentTime + (e.key === 'ArrowRight' ? 1 : -1) * this.end / 36));
        this.pending = true;
        this.seek();
      });
      on(document, 'visibilitychange', () => {
        if (document.hidden) { this.resume = false; this.video.pause(); }
      });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (!this.visible) { this.resume = false; this.video.pause(); }
        else if (!this.started && !this.drag) this.play();
      });
      this.observer.observe(this);
      this.ready();
      this.reveal();
    }
    reveal() {
      if (this.video.readyState < 2) return;
      cancelAnimationFrame(this.revealFrame);
      this.revealFrame = requestAnimationFrame(() => {
        this.revealFrame = requestAnimationFrame(() => {
          if (this.isConnected && this.video.readyState >= 2) this.dataset.frameReady = '';
        });
      });
    }
    ready() {
      if (!Number.isFinite(this.video.duration) || this.video.duration <= 0) return;
      this.end = Math.max(.001, this.video.duration - .04);
      this.status.textContent = '';
      if (this.visible && !this.started && !this.drag) this.play();
    }
    move(e) {
      const drag = this.drag;
      if (!drag || drag.id !== e.pointerId) return;
      const dx = e.clientX - drag.x;
      const dy = e.clientY - drag.y;
      if (!drag.active) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 6) return;
        if (Math.abs(dy) > Math.abs(dx)) { this.stopDrag(); return; }
        drag.active = true;
        this.video.pause();
        this.surface.setPointerCapture(e.pointerId);
        this.dataset.dragging = '';
      }
      const width = this.surface.getBoundingClientRect().width;
      if (!width) return;
      let time = drag.time + dx / width * this.end * (this.dataset.reverse === 'true' ? -1 : 1);
      time = this.dataset.wrap === 'true' ? ((time % this.end) + this.end) % this.end : Math.max(0, Math.min(this.end, time));
      this.target = time;
      this.pending = true;
      this.seek();
    }
    seek() {
      cancelAnimationFrame(this.seekFrame);
      this.seekFrame = requestAnimationFrame(() => {
        if (!this.isConnected || !this.pending || this.video.seeking) return;
        this.pending = false;
        try { this.video.currentTime = this.target; }
        catch (_) { this.status.textContent = 'Touchez pour lire la vidéo.'; }
      });
    }
    stopDrag() {
      const drag = this.drag;
      this.drag = null;
      delete this.dataset.dragging;
      if (drag && this.surface.hasPointerCapture(drag.id)) this.surface.releasePointerCapture(drag.id);
    }
    async play() {
      this.resume = false;
      if (!this.isConnected || !this.visible || document.hidden) return;
      try { await this.video.play(); this.started = true; this.status.textContent = ''; }
      catch (_) { this.status.textContent = 'Touchez le bijou pour lancer la rotation.'; }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.revealFrame);
      cancelAnimationFrame(this.seekFrame);
      if (!this.controller) return;
      this.stopDrag();
      this.controller.abort();
      this.controller = null;
      this.observer.disconnect();
      this.resume = false;
      this.video.pause();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
